import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* getAssignment({ payload: { signal, id, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.assignments.get, id, signal });

    onSuccess && onSuccess(data.result);
    yield put(actions.getAssignmentDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getAssignmentFailed,
      endpoint: api.modifiers.assignments.get.url
    });
  }
}

export const getAssignmentSaga = takeEvery(types.GET_ASSIGNMENT_REQUEST, getAssignment);